@use '@design/design-tokens/typography/typography' as *;

.dateSpan {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  width: 100%;
  text-align: end;
}

.legendWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
